import React from 'react';
import { Link } from 'react-router-dom';

export const NotFoundPage: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <h1 className="text-6xl font-bold text-secondary mb-4">404</h1>
      <h2 className="text-2xl font-bold text-gray-700 mb-6">Page non trouvée</h2>
      <p className="text-gray-600 mb-8 text-center max-w-md">
        La page que vous recherchez n'existe pas ou a été déplacée.
      </p>
      <Link 
        to="/" 
        className="bg-primary text-tertiary px-6 py-3 rounded-lg font-medium hover:bg-yellow-500 transition-colors"
      >
        Retour à l'accueil
      </Link>
    </div>
  );
};
